/**
 * Type guard to check if a value is not `undefined`
 */
export const isDefined = <T>(value: T | undefined): value is T => {
  return value !== undefined;
};
